import React from 'react';

import APIClient from './APIClient';

import Alert from './Alert';

class ResetPasswordForm extends React.Component {
  passwordField = React.createRef();
  passwordConfirmField = React.createRef();

  state = {
    error: null,
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({ error: null });

    const matches = this.props.location.search.match(/^\?userId=(\d+)&token=([a-f0-9]+)$/);

    const userId = parseInt(matches[1], 10);
    const token = matches[2];
    const password = this.passwordField.current.value;
    const passwordConfirm = this.passwordConfirmField.current.value;

    APIClient.shared.postReset(userId, token, password, passwordConfirm)
      .then(() => this.props.history.push('/log-in'))
      .catch(error => this.setState({ error }))
  };

  render() {
    return (
      <div className="ResetPasswordForm">
        {this.state.error &&
          <Alert title="Error" message={this.state.error.message} />
        }
        <form className="Form" onSubmit={this.handleSubmit}>
          <div className="Form__group">
            <label htmlFor="password">Password</label>
            <input type="password" id="password" required minLength={8} ref={this.passwordField} />
          </div>

          <div className="Form__group">
            <label htmlFor="passwordConfirm">Confirm password</label>
            <input type="password" id="passwordConfirm" required minLength={8} ref={this.passwordConfirmField} />
          </div>

          <button type="submit">Reset Password</button>
        </form>
      </div>
    );
  }
}

export default ResetPasswordForm;



// WEBPACK FOOTER //
// ./src/ResetPasswordForm.js